import React from 'react';
import { LoginTemplate } from '@/lib/loginTemplates';
import LoginCard from '@/components/LoginCard';

interface CategorySectionProps {
  title: string;
  templates: LoginTemplate[];
}

const CategorySection: React.FC<CategorySectionProps> = ({ title, templates }) => {
  if (templates.length === 0) return null;
  
  return (
    <div className="mb-12">
      <h2 className="text-2xl font-bold mb-6 capitalize">{title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {templates.map((template, index) => (
          <LoginCard 
            key={template.id} 
            template={template} 
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default CategorySection;